export type BrowserStorageSupport = {
  cookies: boolean;
  localStorage: boolean;
  sessionStorage: boolean;
};

const probeStorage = (storage: Storage, key: string) => {
  try {
    storage.setItem(key, "1");
    storage.removeItem(key);
    return true;
  } catch {
    return false;
  }
};

const probeCookies = () => {
  try {
    document.cookie = "familysafe_storage_probe=1; path=/; SameSite=Lax";
    const available = document.cookie.includes("familysafe_storage_probe=1");
    document.cookie =
      "familysafe_storage_probe=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax";
    return available;
  } catch {
    return false;
  }
};

export const getBrowserStorageSupport = (): BrowserStorageSupport => {
  if (typeof window === "undefined") {
    return {
      cookies: true,
      localStorage: true,
      sessionStorage: true,
    };
  }

  return {
    cookies: probeCookies(),
    localStorage: probeStorage(window.localStorage, "familysafe.localStorage.probe"),
    sessionStorage: probeStorage(window.sessionStorage, "familysafe.sessionStorage.probe"),
  };
};

export const isEssentialStorageAvailable = () => {
  const support = getBrowserStorageSupport();
  return support.cookies && support.localStorage && support.sessionStorage;
};
